import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cartPostAction, getCartItems } from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import {
  clearUnfinalizedPrescription,
  prescriptionPageTabShowItemList,
  setUnfinalizedPrescriptionId,
} from "../../actions/prescriptionAction";
import RxIcon from "../../assets/images/rx-icon.png";
import { getUserDetail } from "../../utils/helper";
import ConfirmDialog from "../ConfirmDialog";
import history from "../../utils/history";
import { renderFormulaList } from "../../actions/formulaAction";
import { getShippingPrice } from "../../actions/profileAction";
const CartItem = ({ item, setIsLoading, selectedShippingAddress }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const dispatch = useDispatch();
  const role = useSelector((state) => state.role.role);
  const removeItem = () => {
    var params = {
      params: {
        action: "removeCartItem",
        itemId: item.prescriptionId,
        isPrescription: 1,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getCartItems(role.val));
        dispatch(getPatientNotification(role.val));
        if (selectedShippingAddress) {
          dispatch(getShippingPrice(selectedShippingAddress.address_id));
        }
      })
    );
  };

  const editItem = () => {
    dispatch(clearUnfinalizedPrescription());
    dispatch(UndoActionCreators.clearHistory());
    dispatch(renderFormulaList(true));
    dispatch(setUnfinalizedPrescriptionId(item.prescriptionId));
    dispatch(prescriptionPageTabShowItemList([3]));
    history.push("/app/prescription", "editFromCart");
  };

  return (
    <div>
      {showConfirmDialog && (
        <ConfirmDialog
          title="Are you sure you want to remove this item?"
          acceptAction={removeItem}
          acceptText="yes"
          rejectText="no"
          closePopup={() => setShowConfirmDialog(false)}
        />
      )}
      <div className="cart_container" id="cart_content">
        {role.val !== 3 && (
          <div className="d-flex justify-content-end">
            <button className="btn btn-orange" onClick={editItem}>
              edit
            </button>
          </div>
        )}
        <div className="cart-icon" style={{ padding: "5px" }}>
          <div
            className="cart-cancel"
            onClick={() => setShowConfirmDialog(true)}
          >
            <FontAwesomeIcon icon={faMinusCircle} />
          </div>
          <img
            style={{ marginLeft: "0px", position: "relative", bottom: "12px" }}
            width="30"
            height="30"
            src={RxIcon}
            alt="rx-icon"
          />
        </div>
        <div className="cart-item">
          {item.isPromo ? (
            <p style={{ marginBottom: "0px" }}>
              Promo Code: {item.description}
            </p>
          ) : (
            <p style={{ marginBottom: "0px" }}>{item.description}</p>
          )}
          <p style={{ marginBottom: "0px" }}>
            Preparation Method:&nbsp;
            <span>{item.prep_name}</span>
          </p>
          {item.formula ? (
            <p style={{ marginBottom: "0px" }}>
              Formula Name:&nbsp;
              <span>{item.formula}</span>
            </p>
          ) : (
            ""
          )}
        </div>
        {!item.isPromo && (
          <>
            <div className="cart-weight">
              <p style={{ display: "inline-block" }}>
                Weight:&nbsp;
                <span>
                  {parseFloat(item.weight).toLocaleString("en-US", {
                    maximumFractionDigits: 1,
                    minimumFractionDigits: 1,
                  })}{" "}
                  grams
                </span>
              </p>
            </div>
          </>
        )}
        <div className="cart-total">
          <p style={{ marginBottom: "0px" }}>
            {item.prep_name === "Compounding"
              ? "Compounding 100g/bottle"
              : item.prep_name === "Foil Bags"
                ? "Foil Bags 300g/Bag" : "Capsules 50/bottle"}
          </p>
        </div>

        <div className="cart-total">
          <p
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "0px",
            }}
          >
            Price
          </p>
          <p>
            {parseFloat(item.total).toLocaleString("en-US", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
              style: "currency",
              currency: "USD",
            })}
          </p>
        </div>
      </div>
    </div>
  );
};
export default CartItem;
